import { render, staticRenderFns } from "./BecomeHostPhone.vue?vue&type=template&id=6216054e&scoped=true&"
var script = {}
import style0 from "./BecomeHostPhone.vue?vue&type=style&index=0&id=6216054e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216054e",
  null
  
)

export default component.exports